import { inject, Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';

import { DepositFolder, DepositFoldersService } from '@connect-services/src/sdk/api';
import {
    defaultPaginationParameters,
    OrderEnum,
    paginationMaxTake,
    PaginationParameters,
} from '@shared/client/models/pagination.model';

@Injectable({
    providedIn: 'root',
})
export class DepositFolderService {
    private readonly depositFoldersService = inject(DepositFoldersService);

    public async getAllDepositFolders(): Promise<DepositFolder[]> {
        const paginationParams: PaginationParameters = {
            ...defaultPaginationParameters,
            order: OrderEnum.ASC,
            orderBy: 'name',
            take: paginationMaxTake,
        };
        let hasNextPage = false;

        const allDepositFolders: DepositFolder[] = [];

        do {
            const paginatedDepositFolder = await firstValueFrom(
                this.depositFoldersService.depositFolderControllerGet({ ...paginationParams }),
            );

            allDepositFolders.push(...paginatedDepositFolder.items);
            paginationParams.page += 1;
            hasNextPage = paginatedDepositFolder.hasNextPage;
        } while (hasNextPage);

        return allDepositFolders;
    }
}
